import React from 'react';
import { motion } from 'framer-motion';

// Slow editorial marquee — one continuous horizontal loop
export const Marquee = ({
  items = [
    'SLOW MADE',
    'NAGPUR · INDIA',
    'HAND POURED',
    'SINCE 2026',
    'SOAP + CHOCOLATE',
    'BY THE SAME HANDS',
  ],
  duration = 60,
  bg = '#0F1B2A',
  fg = '#F1E2C8',
  accent = '#FEF7CD',
}) => {
  const loop = [...items, ...items, ...items];
  return (
    <div
      className="relative overflow-hidden py-8 select-none border-y"
      style={{ backgroundColor: bg, color: fg, borderColor: 'rgba(255,255,255,0.06)' }}
    >
      <motion.div
        className="flex whitespace-nowrap gap-16 will-change-transform"
        animate={{ x: ['0%', '-33.333%'] }}
        transition={{ duration, ease: 'linear', repeat: Infinity }}
      >
        {loop.map((word, i) => (
          <span
            key={i}
            className="font-heading text-4xl sm:text-5xl md:text-6xl font-light tracking-tight inline-flex items-center gap-16"
          >
            {word}
            <span
              className="inline-block w-3 h-3 rounded-full"
              style={{ backgroundColor: accent }}
            />
          </span>
        ))}
      </motion.div>
    </div>
  );
};
